import { LocalDate } from "@js-joda/core"

export type PregnancyStatus = "monitoring" | "delivered"

export type SupportalPregnancyApiDto = {
  id: string
  patientId: string
  status: PregnancyStatus
  estimatedDateOfDelivery?: string
  deliveryDate?: string
  patientOptedInClinically?: boolean
  patientOptedInForSms?: boolean
}

export type Pregnancy = {
  id: string
  patientId: string
  status: PregnancyStatus
  estimatedDateOfDelivery?: LocalDate
  deliveryDate?: LocalDate
  patientOptedInClinically?: boolean
  patientOptedInForSms?: boolean
}

export type UpdatePregnancyApiDto = {
  estimatedDateOfDelivery?: string | null
  deliveryDate?: string | null
  patientOptedInClinically?: boolean
  patientOptedInForSms?: boolean
}

export type CreatePregnancyApiDto = {
  estimatedDateOfDelivery: string | null
  deliveryDate?: string | null
  patientOptedInClinically?: boolean
  patientOptedInForSms?: boolean
}

export const toPregnancy = (dto: SupportalPregnancyApiDto): Pregnancy => ({
  ...dto,
  estimatedDateOfDelivery: dto.estimatedDateOfDelivery
    ? LocalDate.parse(dto.estimatedDateOfDelivery)
    : undefined,
  deliveryDate: dto.deliveryDate ? LocalDate.parse(dto.deliveryDate) : undefined,
})
